import styled, { css } from 'styled-components/macro';
import { device } from 'components/styles/MediaQuery';

export interface ScFormGroupProps {
  marginTop?: number;
  marginBottom?: number;
  isError?: boolean;
}

export const ScFormGroup = styled.div<ScFormGroupProps>`
  &:first-child:nth-last-child(2) {
    margin-bottom: 0;
  }

  &:not(:last-child) {
    margin-bottom: ${({ marginBottom, isError }) =>
      isError
        ? '6px'
        : marginBottom !== undefined
        ? `${marginBottom}px`
        : '24px'};
  }

  &:last-child {
    margin-bottom: 0;
  }

  position: relative;
  margin-top: ${({ marginTop }) => (marginTop ? `${marginTop}px` : 0)};

  & > h3 {
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 4px;
  }

  & > .addons {
    text-align: right;
    font-size: 12px;
    line-height: 20px;
  }

  & > .tooltip {
    text-align: left;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;

export const ScFormGroupBottom = styled.div`
  margin-top: 12px;
  text-align: center;

  .button-default {
    background: none;
    border: none;
    color: ${({ theme }) => theme.grayColor1};
    transition: all 0.2s ease;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    cursor: pointer;

    @media (hover: hover) {
      &:hover {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
  }
`;

export const ScFormSubmitGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 32px;

  & > button {
    max-width: 232px;

    @media (${device.mobile}) {
      max-width: 100%;
    }
  }

  &.de,
  &.fr,
  &.fr-ca {
    & > button {
      font-size: 90%;

      @media (${device.mobile}) {
        font-size: 100%;
      }
    }
  }
`;

export const ScFormRegistration = styled.div`
  min-height: 372px;
`;

export const ScErrorGroup = styled.div`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.whiteColor};
  background-color: ${({ theme }) => theme.grayColor6};
  padding: 16px;
  display: flex;
  gap: 16px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 18px;
  align-items: center;

  img {
    height: 24px;
    width: 24px;
    object-fit: contain;
  }

  ul {
    list-style: none;

    li {
      span {
        text-transform: capitalize;
      }
    }
  }
`;

export const ScFormSection = styled.div<{ noMargin?: boolean }>`
  & > .title {
    padding: 0 16px;
    font-weight: 700;
    font-size: 14px;
    line-height: 1.43;
    color: ${({ theme }) => theme.whiteColor};

    ${({ noMargin }) =>
      !noMargin &&
      css`
        margin-bottom: 16px;
      `}
  }
`;
